export default __webpack_public_path__ + "static/media/ltmbt-logo.bd3c8dd9.svg";